import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { AppRouter } from './components/AppRouter';
import { AuthContainer } from './components/containers/AuthContainer';
import { AlertContainer } from './components/containers/AlertContainer';
import { muiTheme } from './theme';

// Without this, the browser's own back/forward scroll restoration races
// against each page's own `window.scrollTo(0, 0)` on mount - it can win
// and land you mid-page instead, especially on pages whose content grows
// after an async fetch. Every page here already manages its own scroll
// position, so let ours be the only one in control.
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

function App() {
  return (
    // No CssBaseline here deliberately - it would apply a global CSS reset
    // affecting every still-non-MUI page too. This only makes the theme
    // (colors, etc.) available to MUI components via context.
    <ThemeProvider theme={muiTheme}>
      <BrowserRouter>
        <AuthContainer>
          <AlertContainer>
            <AppRouter />
          </AlertContainer>
        </AuthContainer>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
